import { getCSRFTokenValue } from "./helper";

jQuery(function ($) {
  const baseUrl = $("#base-url").data("base-url");

  // Tooltip handler for Basic Information content
  if ($(".basic-information-content").length > 0) {
    const bic = $(".basic-information-content");
    const cbiTO = $("#cbi-tooltip-overlay");

    $(".cbi-tooltip").on("mouseenter", function () {
      const tt = $(this);
      // const y = tt.offset().top - bic.offset().top;

      cbiTO.css("width", bic.width());
      cbiTO.css("top", tt.offset().top);
      cbiTO
        .find(".chevron")
        .css(
          "left",
          2 +
          tt.offset().left -
          cbiTO.find("#cbi-tooltip-content").offset().left +
          "px"
        );
      cbiTO.find(".tooltip-text").html(tt.data("tooltip"));
      cbiTO.removeClass("opacity-0");
    });

    $(".cbi-tooltip").on("mouseleave", function () {
      cbiTO.addClass("opacity-0");
    });
  }

  // Tooltip handler for Human Rights Treaties content
  if ($(".human-rights-treaties-content").length > 0) {
    const hrtc = $(".human-rights-treaties-content");
    const hrtTO = $("#hrt-tooltip-overlay");
    let mouseoutIgnore = false;
    let mouseTimeout;

    $(".hrt-tooltip").on("mouseenter", function () {
      const tt = $(this);
      const status = tt.data("status");
      const year = tt.data("year");
      const desc = tt.data("description");
      const link = tt.data("link");

      // const y = tt.offset().top - hrtc.offset().top;

      hrtTO.find(".hrt-in").hide();

      if (status == "" || status == null) {
        hrtTO.find(".hrt-status-icon img").hide();
      } else {
        if (status === "State Party") {
          hrtTO
            .find(".hrt-status-icon img")
            .attr(
              "src",
              baseUrl +
              "themes/custom/gsod/src/assets/icons/icon-state-party.svg"
            );
          hrtTO.find(".hrt-year").text(year);
          hrtTO.find(".hrt-in").show();
        }
        if (status === "Signatory") {
          hrtTO
            .find(".hrt-status-icon img")
            .attr(
              "src",
              baseUrl + "themes/custom/gsod/src/assets/icons/icon-signatory.svg"
            );
        }
        if (status === "No Action") {
          hrtTO
            .find(".hrt-status-icon img")
            .attr(
              "src",
              baseUrl + "themes/custom/gsod/src/assets/icons/icon-no-action.svg"
            );
        }
        hrtTO.find(".hrt-status-icon img").attr("alt", status);
        hrtTO.find(".hrt-status-icon img").show();
      }

      hrtTO.find(".hrt-status").html(status);
      hrtTO.find(".hrt-desc").html(desc);

      if (link == "" || link == null) {
        hrtTO.find(".hrt-link").hide();
      } else {
        hrtTO.find(".hrt-link a").attr("href", link);
        hrtTO.find(".hrt-link").show();
      }

      mouseoutIgnore = false;
      clearTimeout(mouseTimeout);

      hrtTO.css("width", hrtc.width());
      hrtTO.css("top", tt.offset().top);
      hrtTO.removeClass("opacity-0");
      hrtTO.removeClass("pointer-events-none");
    });

    $(".hrt-tooltip").on("mouseleave", function () {
      mouseTimeout = setTimeout(() => {
        if (!mouseoutIgnore) {
          mouseoutIgnore = false;
          hrtTO.addClass("opacity-0 pointer-events-none");
          // hrtTO.css('top', '-9999px');
        }
      }, 100);
    });

    hrtTO.on("mouseenter", function () {
      mouseoutIgnore = true;
      hrtTO.removeClass("opacity-0 pointer-events-none");
    });

    hrtTO.on("mouseleave", function () {
      mouseoutIgnore = false;
      hrtTO.addClass("opacity-0 pointer-events-none");
      // hrtTO.css('top', '-9999px');
    });
  }

  // Tooltip handler for Democracy Summit Tracking content
  if ($(".democracy-summit-tracking-content").length > 0) {
    // const dst = $('.democracy-summit-tracking-content');
    const dstTO = $("#dst-tooltip-overlay");

    $(".dst-tooltip").on("mouseenter", function () {
      const tt = $(this);

      // dstTO.css('width', dst.width());
      dstTO.css("top", tt.offset().top);
      dstTO.css("left", tt.offset().left - 150);
      dstTO
        .find(".chevron")
        .css(
          "left",
          2 +
          tt.offset().left -
          dstTO.find("#dst-tooltip-content").offset().left +
          "px"
        );
      dstTO.find(".tooltip-text").html(tt.data("tooltip"));
      dstTO.removeClass("opacity-0");
    });

    $(".dst-tooltip").on("mouseleave", function () {
      dstTO.addClass("opacity-0");
    });
  }

  // Download Country PDF ///////////////////////////////////////
  $("#download-country-pdf").on("click", async function () {
    const loader = $(this).siblings(".loader");
    loader.removeClass("invisible");


    const icons = [
      baseUrl + "themes/custom/gsod/src/assets/icons/icon-representation-black.svg",
      baseUrl + "themes/custom/gsod/src/assets/icons/icon-rights-black.svg",
      baseUrl + "themes/custom/gsod/src/assets/icons/icon-participation-black.svg",
      baseUrl + "themes/custom/gsod/src/assets/icons/icon-rule_of_law-black.svg"
    ];

    const iconsBack = [
      baseUrl + "themes/custom/gsod/src/assets/icons/icon-representation-white.svg",
      baseUrl + "themes/custom/gsod/src/assets/icons/icon-rights-white.svg",
      baseUrl + "themes/custom/gsod/src/assets/icons/icon-participation-white.svg",
      baseUrl + "themes/custom/gsod/src/assets/icons/icon-rule_of_law-white.svg"
    ];

    const imageElements = $('.chart-img');

    async function replaceImagesWithIcons(iconsArray) {
      imageElements.each(function (index) {
        if (index < iconsArray.length) { // Check if there is a corresponding icon URL in the array
          $(this).attr('src', iconsArray[index]);
        }
      });
    }

    const canvasElements = [
      "#bar-charty",
      "#indices-chart-RG",
      "#indices-chart-FR",
      "#indices-chart-IA",
      "#indices-chart-PE",
    ];

    const csrfToken = await getCSRFTokenValue(); // Await the promise

    // Define an async function to capture the canvas images
    async function captureCanvasImages() {

      await replaceImagesWithIcons(icons);

      const countryImageUrl = await Promise.all(['#gsod-country-featured-image'].map(async (id) => {
        const elm = $(id);
        const canvas = await html2canvas(elm.get(0));
        let imageBase64;

        // Determine the image format based on the file extension or MIME type
        const src = elm.attr('src');
        const isJPEG = src.toLowerCase().endsWith('.jpg') || src.toLowerCase().endsWith('.jpeg');

        // Convert the canvas to base64 using the determined image format
        if (isJPEG) {
            imageBase64 = canvas.toDataURL('image/jpeg');
        } else {
            imageBase64 = canvas.toDataURL('image/png');
        }
        return imageBase64;
      }))

      const canvasUrls = await Promise.all(canvasElements.map(async (id) => {
        const elm = $(id);
        const chartTitle = elm.find('.chart-title');
        const chartIcon = elm.find('.chart-img');
        const chartValue = elm.find('.chart-value');
        const chartYAxisLegends = elm.find('.chart-y-legend');
        const chartStartYearLegend = elm.find('.indices-start-year');
        const chartEndYearLegend = elm.find('.indices-end-year');
        const chartHeader = elm.find('.chart-header');
        const inCurrent = elm.find('.chart-indices-current');
        const maxIndiceValue = elm.find('.chart-indice');
        const chartCaret = elm.find('.chart-caret');

        // console.log({chartTitle})

        const originalStyles = {
          chartBgColor: elm.css('background-color'),
          chartTextColor: elm.css('color'),
          chartIndicesCurrentColor: inCurrent.css('color'),
          yAxisLegendSize: chartYAxisLegends.css('font-size'),
          startYearLegend: chartStartYearLegend.css('transform'),
          endYearLegend: chartEndYearLegend.css('transform'),
          chartHeaderSpacingY: chartHeader.css('margin-bottom'),
        };

        elm.css('background-color', '#F6F9FC');
        elm.css('color', '#000000');
        chartTitle.css('transform', 'scale(1.5) translate(5%, -50%)');
        chartTitle.css('transform-origin', 'top left');
        chartTitle.css('text-decoration', 'underline');
        chartIcon.css('transform', 'scale(1.25)');
        chartIcon.css('transform-origin', 'top left');
        chartValue.css('transform', 'scale(1.2) translateY(-50%)');
        chartValue.css('transform-origin', 'top right');
        maxIndiceValue.css('transform', 'translateY(40%)');
        chartCaret.css('display', 'inline');

        // Use font size to increase the space taken by legend. Will auto scale the chart size
        chartYAxisLegends.css('font-size', '20px');

        chartStartYearLegend.css('transform', 'scale(1.4) translateY(50%)');
        chartStartYearLegend.css('transform-origin', 'top left');
        chartEndYearLegend.css('transform', 'scale(1.4) translateY(50%)');
        chartEndYearLegend.css('transform-origin', 'top right');
        chartHeader.css('margin-bottom', '2.75rem');

        if (inCurrent.length > 0) {
          inCurrent.css('color', '#000000');
        }

        const canvas = await html2canvas(elm.get(0));
        const imageBase64 = canvas.toDataURL('image/png'); // You can change 'image/png' to other image formats if needed

        // Revert to original stylings
        elm.css('background-color', originalStyles.chartBgColor);
        elm.css('color', originalStyles.chartTextColor);
        chartTitle.css('transform', 'scale(1) translate(0, 0)');
        chartIcon.css('transform', 'scale(1)');
        chartTitle.css('text-decoration', 'none');
        chartValue.css('transform', 'scale(1) translateY(0)');
        maxIndiceValue.css('transform', 'translateY(0)');
        chartYAxisLegends.css('font-size', originalStyles.yAxisLegendSize);
        chartStartYearLegend.css('transform', originalStyles.startYearLegend);
        chartEndYearLegend.css('transform', originalStyles.endYearLegend);
        chartHeader.css('margin-bottom', originalStyles.chartHeaderSpacingY);
        inCurrent.css('color', originalStyles.chartIndicesCurrentColor);
        chartCaret.css('display', 'none');


        return imageBase64;
      }));

      await replaceImagesWithIcons(iconsBack);

      // console.log('xxx', canvasUrls)

      const data = {
        // nid: $(this).data("nid"),
        nid: $("#country-data").data("nid"),
        charts: canvasUrls,
        bluebtn: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHnSURBVHgBtVa9SgNBEP52Q5ooYiFYaLEWioKgVpaej2BrdeAL2FnGlGJj3uBsbH0AC+ML6FkFtNlCO4ugJIJyu87cZY1RkuyZ3Ach7N3sfHxz8ycwAip8DCSwY2EDAasAobI3okXPYgHEBjjX0Uo8zI8YRkCOq2QQwAMWaFiImo6WG15EKryblZiu0tVD/A9nBm0i3GoNJFJhUwmULunhJsYAqYstkj0drek/RKxEYOp6XJJ+svauUybdCw7XpEgY7Etiqvrj7DLLXqMAGCSkaq0hMzZbRUGgb576Fip8IIm4Q4FgVZJIQh/jmYrE6cE8FubKyAsJGUjKjg3fC9urFVwcLeQmo0LekQLCK9NeOwb7J08Uc5GbjDJOUeTsrO+Fp5fPPjIOpyeUt6WD7f64LmYqJe97TKR9jTlcF0eLXA6k7DlV6IkWJ4P2sRyDJG1HlAz2xsf4rZPg6vYtNwlDwNxTwTap/ZQKaT8OBh9bkvsQDy0UBPato/VYZoekhoLgfKdErIr+6pg4TL3ruzePDMrHnB2YEGy6tLwfu/M3kY6WWjx+J0HWG+W9vaGvM/CMtyjvYqwwmno2wnv7AmPIutUMeGjlW7eSmvsmvyFGOcgGowkt5EZ3p+g2YUvqheaCNzCNQQQOX4y6yZoUwldgAAAAAElFTkSuQmCC",
        logo1: "data:image/png;base64,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",
        logo2: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARQAAAA6CAYAAABxoaaLAAAABmJLR0QA/wD/AP+gvaeTAAAWwUlEQVR42u2dCXwURdbAOwkGkHtdEUUUAXVdWJdwyKeuiguy8nnhajjWlUXkEr9wrEAigowshPB9y5WExUggnwRRI0wOEBDQcInmgE2AaJJJMjNJyMlGQORM0ltFXs28rvRkprtnMBvq/X7vB1NTXV1T3f3v9169qkhSM5YBk6LGDJwcdXLA5KirRGUVvRg0OWrPoNfX9JOECBEixCVMJkePdgERNa0Jej36bjFqQoQIaSSPTlzegUCiTANQ5AFToraJkRMiRIiKdRK1XBNMQAdNin5KjJ4QIUIcMnBKZG8Ch0t6gELjLUNNplZiFIUIEcKsk2Q9MGFKgrTTxCgKESJECpoaPcwITBo0snrglJhOYjSFCBHWSbJxoNAAbeRUMZpChAigHPcKUEhQV4ymECE3uJCg6hZvACVocvSrYjSFCGkhMsEU12ZsePz8MeHxB8m/mWo6JnzztnHLNv1eYaFMWjOQAKHOGFCirUMnxLVhbQYnyAEh+/NnhBy0pM44YMl0oSkzD+U/K66cECHNTIITEgLGhG/6isBE9kDrRi+LH6d0e6I3GLJOJkW+jNsjsPiUqOyhvimuoBAhzUjGLt30pocwYVoz7u9bfsmOf3Dauq4EDGd0ThkfliTZj7VFrJKXNcCE6oVZqd/3FFdRiJBmIH9a9lGXMUvjqzUCRSbHrFVYKVOi5ukASh11mRww2WlpHXLAYtEIFJkc84m4kkKENAMZHb55jWaYNGjtuKUfPsja6RtsCiQB2jyNsZP3cV9m7rfM1woTpjMP5D/+HzLkrYn2JkqtqgAXdW4m2oFoWx3ttyfahWhHL/XXH/pC9SYPz/8barh6sQ/NTah1PpdoDNHFRO8QJCEyZvmmBwgYrugEijw6PP5L3N6gSVFDCSiueBqIfejN6FscMNlXdBsBw1m9QCF6jAZzm/Fw30s0gegFojLoGaLRRH/B1T0G3x/UcZ69cOwJL/W7H+rvlCbq3Un0Y6KXUP3LRD8j2oOrS2FDLdNeOvvUDY4f6CHkvCn0ni1Bv1EWQHFYJ/G79MIEQWUUbpNkzj4MyW75xA0qbKSTo3LIvzGDp6/tprROCuIMwASsFMvrzXSoHwF4yC60gOjt/8FAoUC0NvH7CjlrpRzKP9XZp7dR292u87UMQeeOI/qWIAmR4KUf9TcKE6pjwzelGe3L7C/zuhMg1BoFyoyDloJmONTtiJ6CG/Aq0YVE74MHNRLdnFs1AKUNuE6eAqWdmz4GANA66gRKGKoTQbQzuG3zUXmIBqD4Ayi6GARK5ybcyqaEjoOfi+/+F537ZkESEDKzM8EbQCF6WZJlPyN9mZFa8LRhmIDOO5zboZkN9XR0A85U+Z66CTVEL8ID4AooftDWd/BdPdFsouObAMqTRC3wuYqym6t7EzwgNaiPVnj4/TQAJRbVuYvr82KAzPNE73dhwUxFIFkAfWXflQGwGBj2qRx/Ep3zVqIbiZ6H736CMXbnllB4rUNjQV23FIgHMclTObdF0OQaUDYP8xJQDFsFsw9b+noJKDVG4eYDSUE3tqdBVjWg4DfjJS5WEaYCFGoF/MDFbHiorUflFFSl6PP/aADKXFTnANFhRANV6rkDyjJUls+5USYPgNIRAZTBqB7+X9SExXMztMGOO4eOO4+gcmMAZe4Hif3nbUiMCY1N3BO6PnFvI41N3Ba6wTyZJrA5XJ6GZLbvDcdQlm5W+JBR2bZ7VmfbV63Otu1ak23b21itKeS7uTGZZQpzccaBgoOGgbLfEq6wiy3HbjXZMpYssmV8TnQvr+S7HSZb+uK3S9Nu8eHlOQE33j+58keJDuf0FhdAobNCdVD2Obgw1BL7CsquwJsZA0WGt70/PMgVUFYBZfSBTyT6DYJMIDzItN4RDUBpB78PP2gUZLuIvgLnk9y4PPRF8BGc14Qslm+hbp4HLo8Jys4SHQxlfYn+C8oXeuCyTYey/tAOLduD6v4fqhvQ4mASFmt+mgDjMlHZA92G3+Cjl3043Kh1MjIy0uHLr8ku7kegcYYAQ/ZAM1YeKXG8sUkuSRCBQp2BgGzllL2Fji0QTNb0bgQadqKyOyVgKaLw8dEl+h5uvgyuvEDlbTfSBVBmoToPozaeQuXjOaD8yN3w+O3/a5VYwxCiryHw5GgAigQxnbcALPXc7/qSi/m4i6FQWA4CGBVB3UoPgMKgtp8D9X4oP+TifEfg+2KunFlwtVLDdHjLBoppbUJ7AolTHsLkms6LNf9FMdOzLH6H/oBs/POOvsiy/5pse5qHMLmmBD5LlFaKJVYvUAiQJirGxpaR4AlMnFDJ3Oyjy8Ru5mruTR0lNUwjf4Vu0CddAGUlqoOnmHty1ggGShbXj9dQ3ceg7Bmop+aGaAUKlq5E6WLPdHTsIg+AQnOJ0lSA5ClQapqYaWrKPWHTwPuacOXub/FACYtNDNcCE9AK0+adjmh+8LL4PgQOl3QARTH4q7JsE7XABPTSypySPqyNaV8XdCWWxhkdQPknBRprZ6E949F3bRn1WoBC6y8sPvqYDy7Te+gG/IPK9xPQ931cAMWE6tyHjh2kEvPAMRRXMyMDwBW4DJ8Pw/GPI8BpAcoqqSHJa6yK1fIjshqaAsqdqO4xsMroQtTPNADFBmWp9NZW0f920f8cFxDGcavbWjRQwjZu6xUam3RRB1BkCiLc1phlm/6uESZXgyM2O6Lfy3NzO6w+bivTARSqeLqUrOXJn6vZOjloeQJbSsQ6ydQCE6RHMZi8JPdCjEOGoOcQ9F1/MLNlmLFxFZQdjm7iOSoxAwYJPobyOyhrBW9+GWaT2qHZp3rJOa3sjx5KLUDJQC5DH1T+CLI2zKi8DMqSUdnL6Dw9UXmmClDCXNT9GMpy4TczmQju2DMu+v8BikX1RjNg2ZIzT6hlx1BC15vNemACenlu3NZ7HVZKREInsjWB1fNAbHyE0jqxLtcJkwY9YXfsfG/KyQkkwdUsz4GS//+4L+9aM6bqhEmD62NNn+AL/nOmtxXFBpiP/lQTQAlADy296elvjofjeFN9LwqK0jf+Fs6tiYN6o1DZanBRPkcA0AKUV1GdiwCvowikVF9QgcQVmAV7EOCD+/gnsGDqVYAyHtXNAotFgvgSG5NvwA38BLUxw0X/+6FZs1KwuL5RmYVqmUAJW2/+vQGYOAO0SMgiwV4EKrvpGh3XMNn0r7FL4014tijyRHFv6roYAkq27aQpVXa8UaanWrsRWGwleqUJmJwj7tGqCalWxz4qJsu3HQkUyg0BxZZRQdvxwWWb5sLHp+b/cx5MG/fgYhIyMu9vVQEKfaijubpH0NRpIIrvyMjV+FRnDOUtmBrn+0enXUO4uqOQu8WS3vxg1gkfS2d2NqoApT03q4QtiFdg2he3QxMKV7gBwHMq14cet1hSJrm1RKAk7vcCUOTQD1L68m1PiYm5ia5A5pVaMWp9ITD4wCBMGgK0WbYXGwWdU1NbvXHI3kVNVYPU1swwIzBxxFOsGbN9dOnawsM0G2IEIyX1tSiPwHdDuHI/+G46AGqwyrEDwEV6CL21J0kNuSG8OxcA56EP9Aj4/AAc/zB6eEeC9nDz+zrB75sJOgrK1OQusGyo9kK/bxj051mAXh/oD7/4MxD6NFklNtUBXKhZ0P6dHl4fmsrwR3TcHS5c2OFgUfq1CKCQ3JIL3gAKmXKeaLQvBAbZ3gDK6ixrhOFZL1um2RtAMdkzxHYIQm4cITCwesVCid32jGGgZFn3eAMoq7Kts4z2ZZE9Y51XgGLNXC3uMiEq0s5HdX/ONq8BZYEXgGI3JSQo0qNTCssHJxeVLkwqPBWhpsmFpW+YS0sVWaVrsuyjvQCU82tzrIpFXinllr5JFXnzzZX5EWqaWJE7a1v1d3iFrrSwOH2w1uliFa1bWJT2Wy9ernEQe2D6OpjzPcTzeV2lK7hHVO/TeCx1bWhSXB24j+5kBcRY3vdi/xdDm97Pl5qdkNCWTP3aDAFlQ+Jo3GaS9dS7yUWn6onKbrQiuajEsbGSTDJvSTr9QUNAOW5bgPuSWJn7RmJFXi1R2Y2eSS5TbqxEgBBvMCgb6+XL5WpZP705d0v69wQRok3wLJJWVz9Qci42jEHlFC4REHPBclhSX27hiYyHNudx5bslX64dCo01jzUAk69xCn6KtfwJD2HSoNZTJ1PRrExkli2IgKFOH1DsxXhdj7niu34EFFc9gMk1NVfklSZU5bC0aOmdkiPdCRh+1AmTc/Ntmbf7CCh0GrcQFM+G/KDjjSnk+gJFgiA3DTR3RmVsoeJxru7dUkPgvY+O8yRJzsWMWLpDm7/yYSzFfEAHUOrmbUgexNpIkOUAAoksj2ECmmQtm6GMpdg26rNO7MEK66Qi9wtPYYKgspQLzi7QNbtjy5jrg8vEgIIXmLWGtxvLfTischydEXoO3KSXpMazJTQVnI4d+4sBv4Y2aVyMTWfSrQr/Am6WKxerp9SQ8/EaPHSuZi7aQNtT4Lz8gspBkjMblc4m0bwTPF1My+iCyKnQp0FNjFlfeFPTfv8X16cRcJ6RKi4Ny4i930Og9IX6L6AxfBPOze+i9zLUZQmE9P9s4acdPveH756Ez8NVrikdn2ngCvPAoTNMLN+oEtpg4/QYfH4aPg+Dz3zKwa0uxoHOJv4BXD56vW9rNEJhsclBBBC1GtfyrMdt0LiIVpiA1mzPK3PsfL/6RNFtGhYGMj0sI0spqTLvRa0wAb28teo7R6KeyZrahi7402idFIRYLK2vE1CYhEvqKfX0JjnNuUh0x7cxqA5bZ1ILDwhe/7IH3qh4lzia5DaUA0Sc5FzFjLcCeIDr5/Mq/bkIDx+TWPRmZYvq6uE7CrNjKm4fTR7DFiHN/zGr1KM5NWwK9x/od+OH/i1Uf4iHQGFxCZp/8gY3hnRPFrwXylUoXwuAU3NjWTD/EHzO5M5fpuL2bpGcWz2o5fEwF3wXfP4ePq9EY4ynxdUWklKQF3Pt0pfZX1WgkhilwdWpnL8+2UGmHXZ7FwKGap1AkZOKTil2vieLA2dqgMlFAiFHLCaBZMgmVuTn6wSKnFiep0jUM9nTnvU0QEvrkQzZp31kSDYFlAHoArPtK+mYsKSvbLhxcJZsEAeUerj590vKjYno/7O4BxmveF4rKZPj4tENTfvMNqr6LepPGcDiJDr3UA4oF+Bht0vOXeNYsh3dRuBvUkNyGMui/Rj16RPUpx1Sw3YG7Nxfojc1qxOs4n4UurCymgLKZYDKF8jqkOGzK6AkgBXBYE8/T3ABFGqZsPVLNFlvPgRX2XlY3hO9Bmx3v/PQ5jQXQBmMjp+M+vkFlNmgnz3ArWbxlxUwluxYpYUTErmzNUDlkhugHKP7pnDWyWq9MAGt5QO0q7Jt75Ag61k3MCmMzCoaoXR18t7WDRPm+lTm4/R1koaf/toiW3qlG6CUv2vP8OWfQW0KKF3RhWV7dcRJzg2P2qKg4EnujYVXwrKbrg8q24cerH3IqmCuEHugE1F/XpIaZ8V+iI7tCWU05sU2Y9rAAYVfb+QHJvZMznLYgdwFKr2RhfAPVG8GavdOaM/KjUU75D4u0RBDWYzK2D0QIDmXBlxwARR3MRQeKL8AN49aUXehcamWGm//6SqGwgNFkpwbPpnROFyEMrZeb6nkXO1+Czr3Lg7USjHFxbWhCwbVdM46c1e+/vaSku7JRWVXDAJFJtPJiY36QqyN6GNFd686bu/Fa9Sx4jtkble15OrcDgQIZ40ChcRfjjTqi5za6p2C9B4kWa0Xr7Q8WE7wdfp0U0C5C93QzPwsRDdODNJcSbkiFgPlXtQmszJwoiDe/sAPpq35B4n52ezBiYeyIuSeYOkGM1TdOKBcldR3pusDMR66gnc7sjzYqugJqE8juHhTL1DmkrJVwKXwe/C6pH46gYKfkShU3soLQMGBXbqqe43UsKyCnSNFJ1DeQ+5sa3BNWZvMXTuAxgrfTxnIujIuyYVlrxiFCehPRvuSVJk/3DhMGpTCqZnNLjQFlBdVTE93e3oUqQDlHtTmee4NhfMiGFBekVxvqVDF3eSsP8lufmcsMtV5WcHFasqRC8CAMhN939/NuYK4BydGarxiWytQ8H2zystAaYOmffEWl+cNAuVXqD0aAF6HrFsmx93cT/VeuctTCste8hJQThvty7bK3Ee9BJTaOKtzsWAzBwp9oxxBb5i23A3gLv3fCFCeRJ9xYLUTcjtYUhZbwp+rki8RClBsCigPS8p9YZklsI0DCt6+AAefe8F5QsFVY8L2MJkLbhO/t25zAspMFAOje8awNIcSg0CRUIxspeTcemK+ynHf+vQuT86t7kBg8INhl4cLzFLJrLYNSKuyB6tqpe3FI6dLuuP6qcQtITCwGQYKF5htZkA5Cm+R5yASn60SP5HAVWGmKJtt6Qy+Lk2UWuQFoASiWZsceFD9JeVKWrYZ0RKVwPHjyGVZ4gYoY9Dx3ZG7VMkBpZPk3FD7KICnHXrALqAH8VqIDMpL0Ju253UGym4UAO+CZmt4oKxA8SJ/5P6ouTxbJee+uL9EbboCyjx0v7Bx6K0Sg7oiORdY0pfXpwDCGK/d6UmFpbMNAuXcNpvNMe2XXVHRLr3Ktiu9yi670avplbY5yqBs/jiDQLmSfCr3/mYMFFe6XlIug8d/ma4WzNdz6Kb4nReAIkHspB4FXKu4G9wPwczKTRfjmaTuboCCN9i2QtunJefG0eUupjzr0EOsFmztzY3jYTfXwRdAieD6MMcFUEajOkdhJuYn5E5ioCzk2jS5AUoPzp38RiX35QSCTT6a9amHvnlHaLYrzXo1ABRFIlhapf19D2DCtD6tsljhv5sr8w4YsE5WSM1TsuDGYXoarILNUuPEJybdJeWf9ayFIB7eojIEtXk3Ki+FsndR2RJUFwfER3GW0mkAUaBKAPYjrj+7JGW+SiS0X6rye8Yji+QS5Gsshvq8K/UqCkAzC2SO1HjrBQkFFnnXTU0egrc+1T9D2Xw0Ltj6WSA5s5oDUGypBqw4Jh1gapdZa+xtvxPqpqJZlXAE+xqYmUuB/2/hABCPwM3W7nwGddX+sN5u9Dumq3zfBV5cPyKQHIUgrneFzNIM1wUTa1nBTpQIllFlCyKQqNMAFJm4QBYLaiO5yhJE4FCnAyhViT9YO0stT+jb8XbJ93+hrr3k2Z/0ZP3RE6fyBzemlYf1O3IzL2qyE80sdf0Zr1OA5NnfXArU0E9/H1x3f7h+7Xw6GmT6eIcOqCjoRgBxQAtMHFCpLv4r5/ps0AyUyvwpkpAbSZZCkJtZJxvFkDQjMReW3kcAcUEDTHYpXJ3q4nF6YAJ6Nr3KuXUBWejXjQCiRgNMMul6JHEVbxhpLSm3eMyRrv8fTBfiTlKsp14glsoZD2By2FxQ4TDbjpSUtE2rttsMAEVOr7QrIs3mcssTBBaVHgDleEpF7j3i6t1QQt0GtkjxKUn9T54KaQ5Cp5K3F5WNIJssBfNK81a228oG8MeQOEioIZg0aG3maatiWTbNJyHAGGYuzw1W06SK/CE++JMXQoQI+TmFwCDDC0Ch+rYYTSFCbnAhszvZXgFKtW2hGE0hQm54oNgjvAEUEtgdJEZTiJAbXA6dsXchQDhtCCZV9s/ESAoRIuSaECCEGADKxbQKm5ipESJESIPQPBAChuP6gFL8NzGCQoQIUUh6hX2YDqCU5lRVtRejJ0SIkMauT7U9SWNC25/FqAkRIkRVvq4o6EpAccIzoNjWihETIkRIk0JXDxNgjCbWx3t0SplX8l0Y2QvlETFSQoQ0D/k33YtmF7Uu32YAAAAASUVORK5CYII=",
        countryImageUrl
      };

      return data;
    }

    // Call the async function and log the result
    captureCanvasImages().then(data => {
      // console.log(data);
      $.ajax({
        url: `${baseUrl}api/country_pdf/generate`,
        method: "POST",
        cache: false,
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
        },
        data: JSON.stringify(data),
        xhr: function () {
          var xhr = new XMLHttpRequest();
          xhr.onreadystatechange = function () {
            if (xhr.readyState == 2) {
              if (xhr.status == 200) {
                xhr.responseType = "blob";
              } else {
                xhr.responseType = "text";
              }
            }
          };
          return xhr;
        },
        success: function (data) {
          //Convert the Byte Data to BLOB object.
          var blob = new Blob([data], { type: "application/octetstream" });

          //Check the Browser type and download the File.
          var url = window.URL || window.webkitURL;
          var link = url.createObjectURL(blob);

          var a = $("<a />");
          a.attr("download", "country-profile.pdf");
          a.attr("href", link);
          $("body").append(a);
          a[0].click();
          $("body").remove(a);

          loader.addClass("invisible");
        },
      });
    }).catch(error => {
      console.error(error);
    });
  });
});
